import { DetailsContext } from 'pages/Main/Orders'
import { useContext } from 'react'

export const withSelectedOrder = (Component) => (props) => {
  const { order = null } = useContext(DetailsContext)

  return <Component {...props} selectedOrder={order} />
}
